import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import { Dot } from 'lucide-react';

type OtherCaseItemProps = {
    title: string;
    client: string;
    services: string[];
    year: string;
};

export default function OtherCaseItem({
    title,
    client,
    services,
    year,
}: OtherCaseItemProps) {
    return (
        <div className="group border-primary hover:bg-lightyellow flex flex-col gap-2 border-b p-5 lg:grid lg:grid-cols-[40%_25%_30%_5%] lg:items-center lg:gap-2">
            {/* Title */}
            <H3
                variant="notItalic"
                className="hidden overflow-ellipsis group-hover:italic! lg:block lg:not-italic"
            >
                {title}
            </H3>
            <H3 className="overflow-ellipsis lg:hidden">{title}</H3>

            {/* Client */}
            <Label className="">{client}</Label>

            {/* Services */}
            <div className="flex flex-wrap gap-2">
                {services.map((service, idx) => (
                    <div
                        key={idx}
                        className="border-primary rounded-full border px-3 py-1"
                    >
                        <div className="flex items-center gap-2">
                            <Dot className="bg-primary h-2.5 w-2.5 rounded-full lg:h-3.5 lg:w-3.5" />
                            <Label>{service}</Label>
                        </div>
                    </div>
                ))}
                <Label className="my-auto mr-4 ml-auto lg:hidden lg:justify-self-end">
                    {year}
                </Label>
            </div>

            {/* Year */}
            <Label className="mr-4 hidden lg:block lg:justify-self-end">
                {year}
            </Label>
        </div>
    );
}
